import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';

import { IRadioConfig } from './radio.component.interface';

export const RADIO_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(() => RadioSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss'],
    providers: [
        RADIO_CUSTOM_INPUT_ACCESSOR
    ]
})

export class RadioSharedComponent implements ControlValueAccessor {
    @Input() name = '';
    @Input() radioValue;
    @Input() config: IRadioConfig;
    @Input() disable = false;
    // tslint:disable-next-line:no-input-rename
    @Input('value') _value = '';

    onChange: any = () => {};
    onTouched: any = () => {};

    get value(): any {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    registerOnChange(fn): void {
        this.onChange = fn;
    }

    writeValue(value): void {
        if (typeof value !== 'undefined') {
            this.value = value;
        }

        if (typeof value === 'undefined') {
            this.value = '';
        }
    }

    registerOnTouched(fn): void {
        this.onTouched = fn;
    }

    switch(): void {
        this.value = this.radioValue;
    }
}
